import { AnyUser, UserIntersect } from 'types'
import { words } from './lodash.utils'
import { HIRING_URL } from './url.utils'

export const getPublicProfileUrl = (candidateId: number) => {
	return `${HIRING_URL}/public/candidates/${candidateId}`
}

type ParseNameFromUserOptions = {
	useEmail?: boolean
}
export const parseNameFromUser = (
	user?: Partial<Pick<UserIntersect, 'firstName' | 'lastName' | 'name'>> | null,
	options?: ParseNameFromUserOptions
) => {
	const { useEmail } = options || {}
	const { firstName, lastName, email, name } = (user as AnyUser) || {}
	let fullName = name || `${firstName || ''}${lastName ? ` ${lastName}` : ''}`

	if (useEmail && !name && !firstName && !lastName) fullName = email || ''

	return fullName
}

export const parseInitialsFromUser = (
	user?: Partial<Pick<UserIntersect, 'firstName' | 'lastName'>> | null
) => {
	const { name, email } = (user as AnyUser) || {}

	let firstName = user?.firstName
	let lastName = user?.lastName
	const nameWords = name ? words(name) : []

	// If we don't have first and last name we fallback to name
	if (!firstName && nameWords?.length) {
		firstName = nameWords[0]
	}
	if (!lastName && (nameWords?.length ?? 0) > 1) lastName = nameWords[1]

	// If we don't have any name we fallback to email if it exists
	if (!firstName && email) firstName = email
	if (!lastName && email) lastName = email.slice(email.indexOf('@') + 1)

	const firstInitial = firstName ? firstName[0] : ''
	const secondInitial = lastName ? lastName[0] : ''

	return `${firstInitial}${secondInitial}`
}

export const isValidEmail = (email?: string) => {
	if (!email) return false

	const re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

	return re.test(String(email).toLowerCase())
}
